import { HTTP_TOKEN, HTTP_TOKEN_REPORT } from "./http";

export const getShortLinksWhats = params => {
  return HTTP_TOKEN.get("shortlink-whats", { params }).then(result => {
    return result.data;
  });
};

export const getShortLinksWhatsReport = params => {
  return HTTP_TOKEN_REPORT.get("shortlink-whats-log", { params }).then(result => {
    return result.data;
  });
};

export const getShortLinkWhats = (slId) => {
  return HTTP_TOKEN.get(`shortlink-whats/${slId}`).then(result => {
    return result.data;
  });
};


export const createShortLinkWhats = data => {
  return HTTP_TOKEN.post("shortlink-whats", data).then(result => {
    return result.data;
  });
};

export const updateShortLinkWhats = (slId, data) => {
  return HTTP_TOKEN.put(`shortlink-whats/${slId}`, data).then(result => {
    return result.data;
  });
};

export const deleteShortLinkWhats = (slId) => {
  return HTTP_TOKEN.delete(`shortlink-whats/${slId}`).then(result => {
    return result.data;
  });
};
